
import React from 'react';
import ReactMarkdown from 'react-markdown';

interface CardContentProps {
  content: string;
}

export const CardContent = ({ content }: CardContentProps) => {
  return (
    <div className="prose prose-sm dark:prose-invert max-w-none mb-3">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};
